import { textOf } from "../../search";

/** What the address of the sign-in page may carry: that the session expired, and the page to come back to. */
export type SignInSearch = { reason?: "expired"; redirect?: string };

export function signInSearchOf(search: Record<string, unknown>): SignInSearch {
  const redirect = textOf(search["redirect"]);
  return {
    ...(search["reason"] === "expired" ? { reason: "expired" as const } : {}),
    ...(redirect === undefined ? {} : { redirect }),
  };
}
